export default function(to, from, savedPosition) {
      // always scroll to top
      document.getElementById('app-content').scroll(0, 0);
      return { x: 0, y: 0 };
    }
